import { useEffect, useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import apiClient from "../../apiClient";
import { ALL_PERMISSION_LIST } from "../../apiClient/apiEndpoints";

const { useUnoSelector } = UnoStoreHooks;

const PermissionsList = ({ permissionItem }) => {

  return (
    <>
      <div className="permission-card">
        <div className="catheading d-flex justify-content-between">
          <h5>{permissionItem?.displayName}</h5>
          {/* <div className="d-flex gap-1">
                <SimCheckBox disabled />
                <p>All Permissions</p>
              </div> */}
        </div>
       
       {permissionItem?.children?.filter(e => e?.children?.length > 0).map((permission,index)=>{

       return(
        <div className="permission-body">
          
          <div className="permission-header">
            <h6> {permission?.displayName} <span className="extrass">Permissions</span> </h6>
            {/* <div className="d-flex gap-1">
                  <SimCheckBox disabled />
                  <p>Select All</p>
                </div> */}
          </div>

          {permission?.children?.map((subPermission)=>{
            return(
                <div className="permission-body-divide">
                  {/* <SimCheckBox disabled /> */}
                  <div>
                    <h5>
                      {subPermission.displayName}
                    </h5>
                    <p> {subPermission.description} </p>
                  </div>
                </div>
            )
          })}
        </div>
       )
       })}
      </div>
    </>
  )
}



const PermissionMobile = () => {

    const configData = useUnoSelector((state) => state.config);
    const [permissionList, setPermissionList] = useState({});
  
    const getAllPermission = async () => {
      try {
        let data = await apiClient.get(`${configData.config.UNO_URL}${ALL_PERMISSION_LIST}`);
        setPermissionList(data);
      } catch (error) {
        console.log(error);
      }
    };
  
    useEffect(() => {
      getAllPermission();
    }, []);
  
      const findPermission = (key) => {
          let list = permissionList?.children?.find((e) => e.name.toLowerCase() === key.toLowerCase()) || [];
          return list;
      };

  return (
    <>
      <div className="permissionmobile">
        {/* <PermissionHeader /> */}
        <div className="searchwithborder ">
          {/* <SearchBar placeholder="Search Permission...." /> */}
          <h5>Manage Permission</h5>
          <p>Select the permissions you want to assign to an individual</p>


          {/* , "RESOURCE.ALL", "TRAINING.ALL", "GUIDING.ALL", 
             "COLLABORATION.ALL", "AUTHORING.ALL", "CONTENT.VIEW", 
             "GENERAL.ALL", "PRODUCTIVITY.ALL"  */}
          {["TEAM.ALL", "RESOURCE.ALL", "TRAINING.ALL", "GUIDING.ALL", 
             "COLLABORATION.ALL", "AUTHORING.ALL", "CONTENT.VIEW", 
             "GENERAL.ALL", "PRODUCTIVITY.ALL"].map((item) => {
            let permissions = findPermission(item)
            if(permissions?.children?.length === 0) return
            return (
              <PermissionsList
                 permissionItem = {permissions}
              />
            )
          })}

        </div>
      </div>
    </>
  );
};

export default PermissionMobile;
